import { Action } from '@ngrx/store';
import { ErrorEntity, ErrorEntityInterface, ErrorInterface, ErrorStatus } from 'app/core/error-handler/models/index';

import { ErrorActionType } from './error-action-type.model';

export class UnhandledError implements Action {
  public readonly type: ErrorActionType = ErrorActionType.UnhandledError;

  constructor(public readonly payload: ErrorEntityInterface) { }
}

export function createUnhandledError(error: ErrorInterface): UnhandledError {
  return new UnhandledError(new ErrorEntity({
    ...error,
    status: ErrorStatus.Unhandled,
  }));
}
